import './CountOfTotalButton.scss';

import React from 'react';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CountOfTotalButton = ({ count, total, onClick }) => (
  <a
    onClick={onClick}
    style={{ display: 'inline-block' }}
    className="CountOfTotalButton"
  >
    <FontAwesomeIcon icon={faCheckCircle} />

    <span style={{ marginLeft: 4 }}>{`${count} / ${total}`}</span>
  </a>
);

export default CountOfTotalButton;
